import styled from 'styled-components';
import { colors, weight } from 'globalStyle';

export const Card = styled.div`
  width: 280px;
  height: 490px;
  border: 1px solid ${colors.input.inactive};
  border-radius: 25px;
  cursor: pointer;
`;
export const NameContainer = styled.div`
  height: 90px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  background: ${({ initialCustomColor, finalCustomColor }) => (`linear-gradient(
    180deg,
    ${initialCustomColor} 0.15%,
    ${finalCustomColor} 78.53%
  )`)};
  box-shadow: 0px 1px 5px -1px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(8.5px);
  padding: 20px 16px 14px;
`;

export const TextName = styled.div`
  color: ${colors.WHITE};
  font-family: 'Montserrat', sans-serif;
  display: -webkit-box;
  -webkit-line-clamp: ${({ clamp }) => clamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: ${({ fontWeight }) => fontWeight};
  margin: ${({ margin }) => margin};
`;

export const Content = styled.div`
  height: calc(100% - 260px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px 15px 15px;
`;

export const ImgContainer = styled.div`
  width: 100%;
  height: 260px;
  border-radius: 25px 25px 0 0;
  position: relative;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.2) 100%
  );
`;

export const CategoryContainer = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${colors.WHITE};
  position: absolute;
  bottom: -15px;
  right: 20px;
  box-shadow: 0px 1px 5px -1px rgba(0, 0, 0, 0.34);
`;

export const ContainerDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 48%;
    left: 0;
    right: 0;
    border-top: 1px solid ${colors.background.GRAY_3};
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  position: relative;
  width: ${({ width }) => width};

  &:first-child {
    border-right: 1px solid ${colors.background.GRAY_3};
  }

  &:nth-child(n + 3) {
    border-left: 1px solid ${colors.background.GRAY_3};
  }
`;
export const StatusProject = styled.div`
  background-color: ${colors.WHITE};
  top: 5px;
  left: 7px;
  position: absolute;
  padding: 6px 10px;
  border-radius: 25px;
  border: 1px solid ${colors.input.inactive};
  color: ${({ color }) => color};
`;

export const TypeProject = styled.div`
  background-color: ${colors.WHITE};
  top: 40px;
  left: 7px;
  position: absolute;
  padding: 5px 10px;
  border-radius: 25px;
  border: 1px solid ${colors.input.inactive};
  color: ${colors.GRAY_9};
  font-size: 11px;
  font-weight: ${weight.SEMI_BOLD};
  font-style: italic;
  text-transform: uppercase;
`;
